(function() {
  // Temporary redirect for consolidated Cloak Chest pages
  const currentPath = window.location.pathname;
  const newUrl = '/products/cloak-chest-holster';

  // Match patterns: /products/cloak-chest-holster-for-* or /products/cloak-chest-for-*
  const redirectPatterns = [
    /^\/products\/cloak-chest-holster-for-.+$/i,
    /^\/products\/cloak-chest-for-.+$/i
  ];

  // Check if current URL matches any redirect pattern
  const shouldRedirect = redirectPatterns.some(pattern => pattern.test(currentPath));

  if (shouldRedirect && currentPath !== newUrl) {
    window.location.replace(newUrl);
  }
})();
